import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import OrderShow from './BookingShow';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import translate from 'components/hoc/translate';
import { fetchBooking } from 'store/actions/bookings/fetchBookings';
import { fetchOrderBookingActivities } from 'store/actions/orderActivitiesActions';
import { bookingRefundRequest } from 'http/requests/bookings/refundBookingRequests';
import { connect } from 'react-redux';
import { showNotification } from 'store/actions/uiActions';

class BookingShowContainer extends React.Component {
    state = {
        showVoucherModal: false,
    };

    toggleVoucherModal = () => {
        this.setState((state) => {
            return {
                showVoucherModal: !state.showVoucherModal,
            };
        });
    }

    render() {
        const {
            data,
            dispatchNotification,
            dispatchRefreshActivities,
            resourceFetchFailed,
            resourceFetchLoading,
            resourceRefetch,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const refreshActivities = (callback) => {
            const {
                id,
            } = data;

            return dispatchRefreshActivities({
                id: id,
                onSuccess: callback,
                onError: callback,
            });
        };

        const refund = (params) => {

            if (params && params.refund_percentage) {
                params.refund_percentage = parseFloat(params.refund_percentage / 100).toFixed(2);
            }

            return bookingRefundRequest(data.id, params)
                .then(() => {
                    dispatchNotification(translate('notifications.bookings.refund.success'), 'success');
                    resourceRefetch();
                })
                .catch(() => {
                    dispatchNotification(translate('notifications.bookings.refund.failure'), 'warning');
                });
        };

        return <OrderShow
            record={ data }
            refund={ refund }
            refreshActivities={ refreshActivities }
            showVoucherModal={ this.state.showVoucherModal }
            toggleVoucherModal={ this.toggleVoucherModal }
        />;
    }
}

BookingShowContainer.propTypes = {
    data: PropTypes.object,
    dispatchNotification: PropTypes.func.isRequired,
    dispatchRefreshActivities: PropTypes.func.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    resourceRefetch: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const fetchValues = {
    resource: 'bookings',
    action: fetchBooking,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchNotification: (text, type) => {
            dispatch(showNotification(text, type));
        },
        dispatchRefreshActivities: (payload) => {
            dispatch(fetchOrderBookingActivities(payload));
        },
    };
};

const enhance = compose(
    translate,
    connect(null, mapDispatchToProps),
    fetchResourceById(fetchValues)
);

export default enhance(BookingShowContainer);



// WEBPACK FOOTER //
// ./src/pages/bookings/show/BookingShowContainer.js